import { get } from "lodash";
import { parseCAPIMessage } from "@tvg/utils/capiUtils";
import { defaultRegistrationTextsCapiMessage } from "../components/Welcome/helpers";

// Messages
export const getRegistrationTexts = (store) =>
  parseCAPIMessage(
    store,
    "capi.messages.registrationTexts",
    defaultRegistrationTextsCapiMessage
  );

export const getRegistrationTextsPage = (page) => (store) =>
  get(
    parseCAPIMessage(
      store,
      "capi.messages.registrationTexts",
      defaultRegistrationTextsCapiMessage
    ),
    page
  );

export const getPromoCodesMap = (store) =>
  parseCAPIMessage(store, "capi.messages.registrationPromosMap", {});

export const getReferAFriendRegistrationCode = (store) =>
  get(store, "capi.messages.referAFriendRegistrationCode", "");

export const getRobotMessageToggle = (store) =>
  get(store, "capi.messages.robotMessage", "");

export const getLegalContentPrivacyPolicy = (store) =>
  get(store, "capi.messages.privacyPolicy", "");

export const getLegalContentTermsAndConditions = (store) =>
  get(store, "capi.messages.termsAndConditions", "");

// Registration
export const getCurrentStep = (store) => get(store, "registration.currentStep");

export const getLastStep = (store) => get(store, "registration.lastStep");

export const getIsEditing = (store) =>
  get(store, "registration.isEditing", false);

export const getPassThroughAddress = (store) =>
  get(store, "registration.passThroughAddress");

export const getInfoScreenOpen = (store) =>
  get(store, "registration.infoScreen.isOpen");

export const getWelcomeFields = (store) =>
  get(store, "registration.welcome.fields", {});

export const getWelcomeIsFormValid = (store) =>
  get(store, "registration.welcome.isValid", false);

export const getAddressFields = (store) =>
  get(store, "registration.address.fields", {});

export const getAddressIsFormValid = (store) =>
  get(store, "registration.address.isValid", false);

export const getStateSelector = (stateType) => (store) =>
  get(store, `registration.address.fields.${stateType}.state`, "");

export const getSsnFields = (store) =>
  get(store, "registration.ssn.fields", {});
export const getSsnIsFormValid = (store) =>
  get(store, "registration.ssn.isValid", false);

export const getIsTvPreferencesModalOpen = (store) =>
  get(store, "registration.tvPreferences.isTvPreferencesModalOpen", false);

export const getStoredResidentialStateAbbr = (store) =>
  get(store, "registration.address.fields.home.state", false);

export const getStoredSelectedProvider = (store) =>
  get(store, "registration.tvPreferences.selectedProvider", {
    value: "",
    key: ""
  });

export const getFullSsnIsFormValid = (store) =>
  get(store, "registration.fullSsn.isValid", false);

export const getTvProvider = (store) =>
  get(store, "registration.tvPreferences.selectedProvider");

export const getApplicantId = (store) =>
  get(store, "registration.onfido.applicantId");

export const getSdkToken = (store) =>
  get(store, "registration.onfido.sdkToken");

export const getUuid = (store) => get(store, "registration.onfido.uuid");

export const getIsPromoCodeModalOpen = (store) =>
  get(store, "registration.promos.isPromoCodeModalOpen");

export const getStoredPromoCodes = (store) =>
  get(store, "registration.promos.list", {});

export const getStoredSelectedPromoCode = (store) =>
  get(store, "registration.promos.selected", {});

export const getInvalidPromo = (store) =>
  get(store, "registration.promos.invalidPromo", false);

export const getLegalContentIsModalOpen = (store) =>
  get(store, "registration.legalContent.isModalOpen", false);

export const getLegalContentContentType = (store) =>
  get(store, "registration.legalContent.contentType");

export const getLegalContentModalOrigin = (store) =>
  get(store, "registration.legalContent.modalOrigin", "");

// Feature toggles
export const getRegistrationAllPromosWithTC = (store) =>
  get(store, "capi.featureToggles.registrationAllPromosWithTC", false);

export const getEnableRegAutoAddress = (store) =>
  get(store, "capi.featureToggles.enableRegAutoAddress", false);

export const getPerimeterXToggle = (store) =>
  get(store, "capi.featureToggles.enableRegistrationPerimeterX", false);

export const getOnfidoToggle = (store) =>
  get(store, "capi.featureToggles.enableOnfido", false);

export const getFullSsnToggle = (store) =>
  get(store, "capi.featureToggles.regFullSSNCS", false);

export const getSelectedPromo = (store) => {
  const { list, selected } = get(store, "registration.promos", {
    list: {},
    selected: ""
  });

  if (Object.keys(list || {}).length && selected) {
    return { ...list[selected], promocode: selected };
  }

  return {
    code: "",
    promoReference: "",
    title: "",
    text: "",
    name: "",
    description: "",
    promocode: "",
    gtmModule: "Promo To Be Added",
    instructions: "",
    nextSteps: "",
    TCLink: ""
  };
};

export const getPawsWalletAvailable = (store) =>
  get(store, "capi.featureToggles.pawsWalletAvailable", false);
